import { LiHTMLAttributes } from "react";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const Row = styled.div<{ template?: string }>`
  display: grid;
  grid-template-columns: ${({ template }) => template ?? "1fr 1fr"};
  width: 100%;
  gap: 20px;
`;

export const Flex = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  .label {
    display: flex;
    gap: 10px;
    font-size: 14px;
    font-weight: 500;
    color: black;
  }
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid rgb(224, 224, 224);
`;

export const TableContainer = styled.div`
  width: 100%;
  border: 1px;
`;

export const TableBody = styled.div`
  width: 100%;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 3fr 1.75fr 1.75fr 3fr;
  padding: 10px;

  font-size: 14px;
  color: #ababab;
  font-weight: 500;
  font-family: Inter;
  white-space: nowrap;
`;

export const TableContent = styled.div`
  max-height: fit-content;
  width: 100%;
  overflow-y: hidden !important;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #d5d5d5;
    border-radius: 8px;
  }
`;

interface TableItemProps extends LiHTMLAttributes<HTMLLIElement> {
  first?: boolean;
  last?: boolean;
  background?: string;
  loading?: boolean;
}

export const TableItem = styled.li.withConfig({
  shouldForwardProp: (prop) =>
    !["loading", "first", "last", "background"].includes(prop),
})<TableItemProps>`
  display: grid;
  grid-template-columns: 0.5fr 3fr 1.75fr 1.75fr 3fr;
  align-items: center;
  border-top: ${({ first }) => (first ? "1px solid #EAECF0" : "none")};
  border-bottom: 1px solid #eaecf0;
  border-bottom-left-radius: ${({ last }) => (last ? "12px" : "0")};
  border-bottom-right-radius: ${({ last }) => (last ? "12px" : "0")};
  font-family: Inter;
  background: ${({ background }) => background};
  font-size: 14px;
  padding: 10px;
`;
